<template lang="pug">
  section.modulo
    slot(name="header")
    slot(name="feedback")
    slot(name="content")
    slot(name="footer")
</template>

<style lang="scss">
  .modulo {
    margin: 40px 0;

    .more {
      a:hover { color: $color-green-dark }
      &:before {
        content: '';
        margin: 0 10px;
        border-left: 1px solid $color-grey-normal;
      }
    }

    &.-nomargintop { margin-top: 0 }
    &.-nomargin { margin: 0 }
    &.-softpadding { padding: 30px 0; }

    &.-fullheight {
      position: relative;
      min-height: 100%;
      height: 100%;
      padding: 30px 0 100px 0;

      > footer {
        position: absolute;
        width: 100%;
        margin-top: 30px;
      }
    }

    @include media(">=tablet") {
      &.-softpadding > .texto { padding: 0 15px }
    }

    @include media(">=desktop") {
      &.-withpadding > .conteudo { padding: 0 30px }
      &.-padding-desktop > .conteudo { padding: 0 30px }
    }

  }
</style>

<script>
export default {
  name: 'bloco',
  props: ['tag']
}
</script>



// WEBPACK FOOTER //
// Bloco.vue?740dd6dc